import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { ObjFields } from "../../rl-common/shared/shared/types/obj-fields";
import { AnnotatorJSService } from "../core/annotator-js.service";
import { Type } from "../shared/Tools/annotator-tool";
import { AnnotationsStorageService } from "../core/annotations-storage.service";
import { Visibility } from "../../rl-common/shared/shared/types/visibility.enum";

@Component({
  selector: 'rl-annotator-design-tools',
  templateUrl: './annotator-design-tools.component.html',
  styleUrls: ['./annotator-design-tools.component.scss']
})
export class AnnotatorDesignToolsComponent implements OnInit {
  @Input() disabledTools: (ObjFields<Type> | 'SHAPE_NO_CMT')[] = [];
  @Output() onSelectTool: EventEmitter<any> = new EventEmitter<any>();

  constructor(private plugin: AnnotatorJSService, private annotationsStorageService: AnnotationsStorageService) {}

  ngOnInit(): void {
    this.annotationsStorageService.visibility$.subscribe((visibility) => {
      if (visibility === Visibility.PUBLIC) {
        this.currTool = Type.none;
      }
    });
  }

  currTool: Type;
  attributes: any;
  displayShapeMenu: boolean;

  select(tool: any, attributes?: any) {
    this.currTool = this.isSameTool(tool, attributes) ? Type.none : tool;
    this.attributes = attributes;
    this.plugin.selectTool(this.currTool, attributes);
    this.onSelectTool.emit(this.currTool);
    this.displayShapeMenu = false;
  }

  isSelected = (tool: any) => this.currTool == tool;

  isSameTool(tool, attributes): boolean {
    return this.currTool == tool && !attributes;
    // return this.currTool == tool && (!attributes || (attributes && this.attributes == attributes));
  }

  isDisabled = (type : string) => this.disabledTools?.indexOf(type) > -1
}
